import apiFetch from '../apiFetch'
export default function (dossierId, token) {
  return apiFetch({ endPoint: `order?SaleId=${dossierId}`, method: 'GET', body: null, token: token })
}
